import {DriverVehicleReservationStatusEnum} from '@/services/api-clients';

export function driverVehicleReservationStatusIconFilter(value: DriverVehicleReservationStatusEnum): string {
  switch (value) {
    case DriverVehicleReservationStatusEnum.Waiting: return 'mdi-clock-outline';
    case DriverVehicleReservationStatusEnum.Approved: return 'mdi-check';
    case DriverVehicleReservationStatusEnum.Cancelled: return 'mdi-close-circle';
  }
}
